import { render, staticRenderFns } from "./AwardTrophyForm.vue?vue&type=template&id=b8f6c856&scoped=true&"
import script from "./AwardTrophyForm.vue?vue&type=script&lang=js&"
export * from "./AwardTrophyForm.vue?vue&type=script&lang=js&"
import style0 from "./AwardTrophyForm.vue?vue&type=style&index=0&id=b8f6c856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f6c856",
  null
  
)

export default component.exports